import React from 'react'
import * as Sentry from '@sentry/react'
import FallBack from '_components/FallBack'

const WithErrorBoundary = (WrappedComponent, fallback = () => <FallBack />) =>
  Sentry.withErrorBoundary(WrappedComponent, {
    fallback,
  })

export default WithErrorBoundary
